import api from 'services/api.service';

const resource = '/deals';

export const getDealsByTeamId = ({ teamId }) => api
  .get(`${resource}/get-deals-by-team`, { teamId });

export const deleteTransaction = ({ dealId }) => api
  .delete(`${resource}/${dealId}`);
